import { Molecule, wrap } from 'AppReact';
import styled, { css } from 'styled-components';
import { Mt2, GenericWrapper } from 'wrappers';
import { SecondaryTextXs400, SecondaryTextSm, Icon } from 'atoms';
import { GreenTickSvg } from 'components/icons';

const template = styled.div`
  ${({ theme, displayState }) => css`
    padding: ${displayState?.padding ?? '15px'};
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: ${displayState?.selected ? `${theme?.colour?.primary}0D` : '#FFFFFF'};
    white-space: nowrap;

    cursor: pointer;
    
    &:hover {
      background-color: ${`${theme?.colour?.primary}0D`};
    }
  `}
`;


export default Molecule({
  template,
  type: 'button',
  atoms: [
    {
      wrapper: GenericWrapper,
      name: 'LeftSideWrapper',
      atoms: [
        {
          component: SecondaryTextSm,
          name: 'Label',
          displayValue: ({ label }) => label
        },
        {
          component: wrap(SecondaryTextXs400, Mt2),
          name: 'Dates',
          renderIf: ({ startDate, endDate }) => startDate && endDate,
          displayValue: ({ startDate, endDate }) => `${startDate} - ${endDate}`
        },
        {
          component: wrap(SecondaryTextXs400, Mt2),
          name: 'Dates',
          renderIf: ({ singleDate }) => singleDate,
          displayValue: ({ singleDate }) => singleDate
        }
      ]
    },
    {
      component: Icon,
      name: 'Icon',
      renderIf: ({ displayIcon, selected }) => displayIcon && selected,
      displayValue: ({ }) => GreenTickSvg({})
    }
  ]
})